import {
  ID_TOKEN,
  ACCESS_TOKEN,
  GEARS_TOKEN_EXPIRATION_DATE,
  GEARS_TOKEN,
} from "@constants";
import { SET_USER, UNSET_USER, UserAction, UserState } from "../types/user";

export const user = (
  state: UserState = null,
  action: UserAction
): UserState => {
  switch (action.type) {
    case SET_USER:
      if (action.user) {
        const { id_token, access_token } = action.user;
        //console.info("set id_token:"+id_token);
        sessionStorage.setItem(ID_TOKEN, id_token);
        sessionStorage.setItem(ACCESS_TOKEN, access_token);
      }

      return action.user;
    case UNSET_USER:
      sessionStorage.removeItem(ID_TOKEN);
      sessionStorage.removeItem(ACCESS_TOKEN);
      sessionStorage.removeItem(GEARS_TOKEN_EXPIRATION_DATE);
      sessionStorage.removeItem(GEARS_TOKEN);
      return null;
    default:
      return state;
  }
};
